import { render, staticRenderFns } from "./ApiCreated.vue?vue&type=template&id=2ef790bd&scoped=true"
import script from "./ApiCreated.vue?vue&type=script&lang=js"
export * from "./ApiCreated.vue?vue&type=script&lang=js"
import style0 from "./ApiCreated.vue?vue&type=style&index=0&id=2ef790bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef790bd",
  null
  
)

export default component.exports